import * as React from "react"
import { SVGProps } from "react"
const AnreiseIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 520" {...props}>
        <path
            d="M408 105c0-6 2-10 3-16 2-5-3-10-9-11-4 0-8 3-8 6-2 6-2 12-2 18 5 1 11 2 16 3Z"
            className="a"
        />
        <path
            d="M408 105c0-6 2-10 3-16 2-5-3-10-9-11-4 0-8 3-8 6-2 6-2 12-2 18 5 1 11 2 16 3Z"
            className="b"
        />
        <path
            d="M414 170c-7 0-14-2-21-2 1 14-3 28 0 42 6-1 13 0 18-4 1-1 0-4 0-7 2-10 4-19 3-29Z"
            className="a"
        />
        <path
            d="M414 170c-7 0-14-2-21-2 1 14-3 28 0 42 6-1 13 0 18-4 1-1 0-4 0-7 2-10 4-19 3-29Z"
            className="b"
        />
        <path
            d="M393 266c3 16 4 32 5 48 0 25-4 48-8 73-4 29-3 56 1 85 1 2 2 4 4 5 5 2 12 3 14-2 3-6 0-12-1-18-4-35 2-68 7-103 5-29 5-58-1-86-7 0-14-2-21-2Z"
            className="a"
        />
        <path
            d="M393 266c3 16 4 32 5 48 0 25-4 48-8 73-4 29-3 56 1 85 1 2 2 4 4 5 5 2 12 3 14-2 3-6 0-12-1-18-4-35 2-68 7-103 5-29 5-58-1-86-7 0-14-2-21-2Z"
            className="b"
        />
        <path
            d="M349 279a41 41 0 0 1-1-11 122.52 122.52 0 0 0 19-2c23-1 46 0 69-3 14-2 28-4 41-8 3-2 9-1 9-6 2-14-3-27-4-41-1-3 0-8-5-8-10-1-20 4-30 6s-19 3-28 4c-25 1-50 2-75 4-2-3 1-8-2-11-3-1-6 2-8 4-6 5-9 11-15 15-8 8-14 17-21 25-2 2-2 6 0 7 16 10 31 17 47 28 1 1 3 3 4-3ZM462 112c-1 3-1 7-2 10-16-1-31-7-46-12-30-8-59-17-90-15-2 1-3 3-4 5-2 15-7 30-7 45a2.15 2.15 0 0 0 2 2c24 3 46 5 69 11 21 6 41 14 62 17a35.53 35.53 0 0 0-2 10c0 2 1 4 5 3 1-1 3-2 4-3 3-2 7-2 10-4 13-8 27-14 39-24 3-7-6-12-11-17-9-10-15-22-26-31q-1.5 0-3 3Z"
            className="b"
        />
    </svg>
)
export default AnreiseIcon
